import { gql } from "@apollo/client";

export const ADD_QUOTE = gql`
  mutation addQuote($input: QuoteInput!) {
    addQuote(input: $input)
  }
`;

export const ADD_QUOTE_ASSET = gql`
  mutation addQuoteAsset($input: QuoteInput!) {
    addQuoteAsset(input: $input)
  }
`;

export const UPDATE_QUOTE = gql`
  mutation updateQuote($input: UpdateQuoteInput!) {
    updateQuote(input: $input) {
      quoteId
      priceCards {
        guid
        version
        priority
        allowRiskBasePricing
      }
    }
  }
`;
